import styled, { css, keyframes } from 'styled-components'
import get from 'lodash/get'

const ellipsis1 = keyframes`
  0%   { transform: scale(0) }
  100% { transform: scale(1) }
`

const ellipsis2 = keyframes`
  0%   { transform: translate(0, 0) }
  100% { transform: translate(calc(var(--transform-direction) * 19px), 0) }
`

const ellipsis2Inline = keyframes`
  0%   { transform: translate(0, 0) }
  100% { transform: translate(calc(var(--transform-direction) * 10px), 0) }
`

const ellipsis3 = keyframes`
  0%   { transform: scale(1) }
  100% { transform: scale(0) }
`

export const Dot = styled.div`
  border-radius: 50%;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
`

const baseLoaderStyles = css`
  background-color: transparent;
  display: flex;
  position: relative;
`

export const LoaderBase = styled.div<{ top: string; margin?: string }>`
  ${baseLoaderStyles}
  width: 64px;
  height: 30px;
  inset-block-start: ${props => `${props.top}px`};
  margin-inline: auto;
  margin-block: ${props => (props.margin ? `${props.margin}px;` : `20px;`)};

  ${Dot} {
    position: absolute;
    inset-block-start: 10px;
    width: 11px;
    height: 11px;
    background: ${({ color, theme }) => color || theme.colors.brand1};

    &:nth-child(1) {
      inset-inline-start: 6px;
      animation: ${ellipsis1} 0.6s infinite;
    }

    &:nth-child(2) {
      inset-inline-start: 6px;
      animation: ${ellipsis2} 0.6s infinite;
    }

    &:nth-child(3) {
      inset-inline-start: 26px;
      animation: ${ellipsis2} 0.6s infinite;
    }

    &:nth-child(4) {
      inset-inline-start: 45px;
      animation: ${ellipsis3} 0.6s infinite;
    }
  }
`

export const LoaderInline = styled.div<{ top: string }>`
  ${baseLoaderStyles}
  width: 30px;
  height: 10px;
  margin-inline: 0;
  margin-block: 0;
  inset-block-start: ${props => `${props.top}px`};

  ${Dot} {
    position: absolute;
    inset-block-start: 2px;
    width: 7px;
    height: 7px;
    background: ${props => get(props.theme, `colors.${props.color}`) || props.theme.colors.brand1};

    &:nth-child(1) {
      inset-inline-start: 3px;
      animation: ${ellipsis1} 0.6s infinite;
    }

    &:nth-child(2) {
      inset-inline-start: 3px;
      animation: ${ellipsis2Inline} 0.6s infinite;
    }

    &:nth-child(3) {
      inset-inline-start: 13px;
      animation: ${ellipsis2Inline} 0.6s infinite;
    }

    &:nth-child(4) {
      inset-inline-start: 22px;
      animation: ${ellipsis3} 0.6s infinite;
    }
  }
`
